import Vue from 'vue'
import VueRouter from 'vue-router'
//import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'show-event-view-home',
    component: () => import('../views/show-events/show-events.vue')
  },
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: HomeView
  // },
  {
    path: '/add-event',
    name: 'add-event-view',
    component: () => import('../views/add-event/add-event.vue')
  },
  {
    path: '/events',
    name: 'show-event-view',
    component: () => import('../views/show-events/show-events.vue')
  },
  {
    path: '/event-detail',
    name: 'event-detail',
    component: () => import('../views/event-detail/event-detail.vue')
  },
  {
    path: '/settings',
    name: 'settings-view',
    component: () => import('../views/settings/settings-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/host-dashboard',
    name: 'host-dashboard-view',
    component: () => import('../views/host-dashboard/host-dashboard-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/subscriptions',
    name: 'subscriptionView',
    component: () => import('../views/subscriptions/subscriptions-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/contact',
    name: 'contact-us',
    component: () => import('../views/contact/contact-us.vue')
  },  
  {
    path: '/privacy-policy',
    name: 'privacy-policy-view',
    component: () => import('../views/privacy-term/privacy-policy.vue')
  },
  {
    path: '/terms-of-use',
    name: 'terms-conditions-view',
    component: () => import('../views/privacy-term/terms-condition.vue')
  },
  {
    path: '/help',
    name: 'help-view',
    component: () => import('../views/help/help-view.vue')
  },
  {
    path: '/user-management',
    name: 'user-management-view',
    component: () => import('../views/user-management/user-management-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/ad-management',
    name: 'ad-management-view',
    component: () => import('../views/advertisement/ad-management-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/event-approval',
    name: 'event-approval-view',
    component: () => import('../views/event-approval/event-approval-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/admin/dashboard',
    name: 'admin-dashboard-view',
    component: () => import('../views/admin/admin-dashboard-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/gallery',
    name: 'gallery-view',
    component: () => import('../views/gallery/gallery-view.vue')
  },
  {
    path: '/upload-gallery',
    name: 'upload-gallery-view',
    component: () => import('../views/gallery/upload-gallery-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/own/gallery',
    name: 'user-gallery-view',
    component: () => import('../views/gallery/user-gallery-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  {
    path: '/admin/gallery',
    name: 'admin-gallery-view',
    component: () => import('../views/gallery/admin-gallery-view.vue'),
    meta: { robots: 'noindex, nofollow' }
  },
  // {
  //   path: '/advertisement/upload',
  //   name: 'upload-ads-view',
  //   component: () => import('../views/advertisement/upload-ads.vue')
  // },
  
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
